import cfg from 'cfg';
import auth from '../auth';
import { httpMethods, requestAsync, UPDATE_DEFAULT } from '../requery/actions';
import { toIdArray } from '../helpers';

export const fetchTournaments = () => {
    return requestAsync({
        url: `${cfg.apis.ss2}/tournaments`,
        update: {
            tournaments: UPDATE_DEFAULT.MERGE
        },
        transform: tournaments => ({
            tournaments: tournaments.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {})
        }),
        list: tournaments => ({
            tournaments: () => tournaments.map(t => t.id)
        }),
        queryKey: 'GET:tournaments',
        options: {
            method: httpMethods.GET
        }
    });
};

export const fetchTeams = () => {
    return requestAsync({
        url: `${cfg.apis.ss2}/teams`,
        update: {
            teams: UPDATE_DEFAULT.MERGE
        },
        transform: teams => ({
            teams: teams.reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {})
        }),
        list: teams => ({
            teams: () => teams.map(t => t.id)
        }),
        queryKey: 'GET:teams',
        options: {
            method: httpMethods.GET
        }
    });
};

export const fetchInterests = () => (dispatch, getState) => {
    const { _id: userId } = getState().user;

    if (userId == null) {
        return dispatch({
            type: 'err'
        });
    }

    return dispatch(
        requestAsync({
            url: `${cfg.dash.api.host}/api/users/${userId}/interests?access_token=${auth.getAccessToken()}`,
            update: {
                userInterests: UPDATE_DEFAULT.MERGE
            },
            transform: (interests = []) => ({
                userInterests: interests.reduce((acc, curr) => ({ ...acc, [curr._id]: curr }), {})
            }),
            list: (interests = []) => ({
                userInterests: () => toIdArray(interests)
            }),
            queryKey: 'GET:userInterests',
            options: {
                method: httpMethods.GET
            }
        })
    );
};

export const postInterest = interest => (dispatch, getState) => {
    const { _id: userId } = getState().user;

    if (userId == null) {
        return dispatch({
            type: 'err'
        });
    }

    return dispatch(
        requestAsync({
            url: `${cfg.dash.api.host}/api/users/${userId}/interests?access_token=${auth.getAccessToken()}`,
            body: interest,
            update: {
                userInterests: UPDATE_DEFAULT.MERGE
            },
            transform: ({ interest = {} }) => ({
                userInterests: { [interest._id]: interest }
            }),
            list: ({ interest = {} }) => ({
                userInterests: prevInterests => prevInterests.concat(interest._id)
            }),
            queryKey: 'POST:userInterests',
            options: {
                method: httpMethods.POST
            }
        })
    );
};

export const putInterest = (interestId, interest) => (dispatch, getState) => {
    const { _id: userId } = getState().user;

    if (userId == null || interestId == null) {
        return dispatch({
            type: 'err'
        });
    }

    return dispatch(
        requestAsync({
            url: `${
                cfg.dash.api.host
            }/api/users/${userId}/interests/${interestId}?access_token=${auth.getAccessToken()}`,
            body: interest,
            update: {
                userInterests: UPDATE_DEFAULT.MERGE
            },
            transform: (interest = {}) => ({
                userInterests: { [interest._id]: interest }
            }),
            list: () => ({
                userInterests: prevInterests => prevInterests
            }),
            queryKey: 'PUT:userInterests',
            options: {
                method: httpMethods.PUT
            }
        })
    );
};

export const deleteInterest = interestId => (dispatch, getState) => {
    const { _id: userId } = getState().user;

    if (userId == null) {
        return dispatch({
            type: 'err'
        });
    }

    return dispatch(
        requestAsync({
            url: `${
                cfg.dash.api.host
            }/api/users/${userId}/interests/${interestId}?access_token=${auth.getAccessToken()}`,
            update: {
                userInterests: UPDATE_DEFAULT.MERGE
            },
            transform: () => ({
                userInterests: {}
            }),
            list: () => ({
                userInterests: prevInterests => prevInterests.filter(i => i !== interestId)
            }),
            queryKey: 'DELETE:userInterests',
            options: {
                method: httpMethods.DELETE
            }
        })
    );
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/interests-page/actions.js
 **/